import type { PrivacyStrings } from "../../types";

export const mobilePrivacy: PrivacyStrings = {
  "title": "Cate Mobile 隐私",
  "lastUpdated": "最后更新：2026 年 11 月 3 日",
  "sections": [
    {
      "title": "关于本补充说明",
      "paragraphs": [
        {
          "nodes": [
            "本补充说明涵盖适用于 iPhone 的 Cate Mobile。请结合 Cate 主隐私政策阅读；主政策说明数据控制者及其联系方式、Cate Connect 和外部 AI 提供商，以及你的隐私权利。访问本页面适用主政策中关于网站的说明。"
          ]
        },
        {
          "nodes": [
            {
              "link": "Cate 隐私政策",
              "href": "/privacy"
            }
          ]
        }
      ]
    },
    {
      "title": "设备上的数据",
      "paragraphs": [
        {
          "nodes": [
            "Cate Mobile 在设备上保存已配对工作空间记录和应用设置，并在 iOS 钥匙串中保存设备和通知机密。工作空间文件和会话仍保存在 runtime 电脑上；应用通过主政策所述的加密连接接收显示和控制工作空间所需的内容。使用 Forget 可移除本地配对记录，但不会删除工作空间文件，也不会撤销电脑上该设备的访问权限；如需撤销，请在电脑上管理配对设备。删除应用不一定会清除钥匙串条目。"
          ]
        }
      ]
    },
    {
      "title": "可选的推送通知",
      "paragraphs": [
        {
          "nodes": [
            "如果你允许通知，Apple 会签发推送令牌。配对的 runtime 保存该令牌和为你的设备加密通知所用的密钥。Cate Connect 将令牌和加密内容转发至 Apple Push Notification service，不会将推送令牌持久保存在其应用存储中。通知扩展使用钥匙串中的密钥在设备上解密内容。Apple 根据其自身隐私政策处理投递信息。你可以在 iOS 设置中关闭通知，并在电脑上的 Cate 中管理配对设备访问权限。"
          ]
        },
        {
          "nodes": [
            {
              "link": "Apple 隐私政策",
              "href": "https://www.apple.com/legal/privacy/"
            }
          ]
        }
      ]
    },
    {
      "title": "目的与选择",
      "paragraphs": [
        {
          "nodes": [
            "我们根据 GDPR 第 6(1)(b) 条处理提供你所请求功能所需的配对和通知信息。通知还需要你的 iOS 权限。Cate Mobile 不包含广告或第三方分析 SDK。主政策所述的桌面崩溃报告和使用分析适用于桌面应用。"
          ]
        }
      ]
    },
    {
      "title": "联系与权利",
      "paragraphs": [
        {
          "nodes": [
            "有关数据控制者地址、联系方式、GDPR 权利和监管机构，请参阅 Cate 主隐私政策。咨询连接记录时，请提供相关 runtime 标识，但不要发送私有配对密钥或工作空间内容。"
          ]
        },
        {
          "nodes": [
            {
              "link": "Cate 隐私政策",
              "href": "/privacy"
            }
          ]
        }
      ]
    }
  ]
};
